import { render } from "./IPModal.vue?vue&type=template&id=f7caf6f0"
import script from "./IPModal.vue?vue&type=script&lang=js"
export * from "./IPModal.vue?vue&type=script&lang=js"

import "./IPModal.vue?vue&type=style&index=0&id=f7caf6f0&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__